export default "__VITE_ASSET__B3PfE_1n__"